import styled from 'styled-components';
import { outlineGray, primaryColorLight, primaryColorWeak, textGrey } from '../../../../config/colors';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  .table-history {
    table-layout: auto;
    width: 100%;
    border-spacing: 0;

    .th-history {
      background-color: whiteSmoke;
    }

    .th-history,
    .td-history {
      margin: 0;
      padding: 0.5rem;
      border: 2px solid white;
      border-left: 0;
      text-align: center;
      :last-child {
        border-right: 0;
      }
    }
    .tbody-history {
      .td-history {
        height: 3.5rem;
        :last-of-type {
          padding: 0;
          svg {
            transition: transform 0.2s linear;
          }
        }
      }
    }
  }

  .td-history {
    background-color: #fff7f6;
    // opacity: 0.8;
  }
  .hide {
    display: none;
  }
`;
